import { Injectable, signal } from '@angular/core';

export interface HeaderAction {
  label: string;
  icon?: 'search' | 'plus' | 'edit';
  onClick: () => void;
}

export interface LayoutConfig {
  title: string;
  title2?: string;
  breadcrumb?: string;
  showBackButton?: boolean;
  backLabel?: string;
  headerAction?: HeaderAction;
  switchPlaces?: boolean;
  darkHeader?: boolean;
}

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly breadcrumb = signal<string | null>(null);
  readonly title = signal<string>('');
  readonly title2 = signal<string | null>(null);
  readonly collapsed = signal<boolean>(false);
  readonly mobileOpen = signal<boolean>(false);
  readonly showBackButton = signal<boolean>(false);
  readonly backLabel = signal<string>('Go back');
  readonly headerAction = signal<HeaderAction | null>(null);
  readonly switchPlaces = signal<boolean>(false);
  readonly darkHeader = signal<boolean>(false);

  set(config: LayoutConfig): void {
    this.title.set(config.title);
    this.title2.set(config.title2 ?? null);
    this.breadcrumb.set(config.breadcrumb ?? null);
    this.showBackButton.set(config.showBackButton ?? false);
    this.backLabel.set(config.backLabel ?? 'Go back');
    this.headerAction.set(config.headerAction ?? null);
    this.switchPlaces.set(config.switchPlaces ?? false);
    this.darkHeader.set(config.darkHeader ?? false);
  }
}
